import { render, staticRenderFns } from "./LostFoundModal.vue?vue&type=template&id=3e5bd68a"
import script from "./LostFoundModal.vue?vue&type=script&lang=js"
export * from "./LostFoundModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports